import {
  Col,
  Row,
  Button,
  Form,
  Input,
  DatePicker,
  TimePicker,
  Radio,
  Card,
} from "antd";
import React,{useState} from "react";
import { message } from "antd";
import { uploadDocument } from "../../Redux/Services/CustomerNotification";
import { connect } from "react-redux";

import moment from "moment";
import "./style.scss";
import InputTextField from "../../Components/Input/InputTextField";

const CustomerNotification = (props) => {
  const [form] = Form.useForm();
  const { RangePicker } = DatePicker;
  const { TextArea } = Input;
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [fileList, setFileList] = useState({});
  const [currentDatePicker, setCurrentDatePicker] = useState("");
  const [scheluderType, setScheluderType] = useState(null);
  const [loading, setLoading] = useState(false);
  const [rangeDates, setRangeDates] = useState(null);

  const currentHour = moment()?.hour();
  const currentDate = moment().format("YYYY-MM-DD");

  const format = "HH:mm";

  function range(start, end) {
    const arr = [];
    let i = start;
    while (i <= end) {
      arr.push(i);
      i++;
    }
    return arr;
  }

  const onChangeRadio = (e) => {
    setScheluderType(e.target.value);
    setFromDate(null);
    setToDate(null);
    setRangeDates(null);

  form.setFieldsValue({ rangeTime: null });
  };
  const onFinish = (values) => {
    const obj =
      scheluderType == "Instant"
        ? {
            title: values?.title,
            message: values?.message,
            group: values?.group,

            startDate: fromDate,
            endDate: toDate,
            notificationType: values?.notificationType,
            pageName: values?.pageName,
            scheluderType: scheluderType,
          }
        : {
            title: values?.title,
            message: values?.message,
            group: values?.group,

            startDate: fromDate,
            endDate: toDate,
            notificationType: values?.notificationType,
            pageName: values?.pageName,
            scheluderType: scheluderType,
            startTime: `${currentDatePicker} ${values?.startTime?.format(
              "HH:mm"
            )}`,
          };

    setLoading(true);
    if (obj) {
      (async () => {
        try {
          const res = await props.uploadDocument({
            info: JSON.stringify(obj),
            file: values?.File?.file?.originFileObj || null,
          });
          setLoading(false);
          form && form.resetFields();
        } catch (error) {
          setLoading(false);
          form && form.resetFields();
        } finally {
          setLoading(false);
          form && form.resetFields();
        }
      })();
    }
  };

  const onReset = () => {
    form.resetFields();
  };

  const layout = {};

  const arrayDropdown = [
    "my-info",
    "mandate-form",
    "loan-info",
    "bike-service",
    "flyy-offer",
    "flyy-reward",
    "flyy-quiz",
    "flyy-wallet",
    "flyy-gift-card",
    "flyy-invite",
    "web-view",
    "nitro-form",
    "vehicle_docs",
    "other",
  ];
  const notificationDropdownValues = [
    "Daily Engagement",
    "Important Notification",
    "Offers",
  ];
  const groupDropdownValues = ["Loan Customer", "All"];

  let dropdownNames = arrayDropdown?.map((re) => {
    return { label: re, value: re };
  });

  let notificationDropdown = notificationDropdownValues?.map((re) => {
    return { label: re, value: re };
  });

  let groupDropdown = groupDropdownValues?.map((re) => {
    return { label: re, value: re };
  });

  const propsUpload = {
    maxCount: 1,
    multiple: false,
    //  showUploadList: false,

    beforeUpload: (file) => {
      const isPNG =
        file?.type === "image/png" ||
        file?.type === "image/jpeg" ||
        file?.type === "image/jpg";
      if (!isPNG) {
        message.error(`${file?.name} is not a Image file`);
      } else {
        setFileList(file);
      }
      return false;
    },
    onRemove: (file) => {
      setFileList("");
      //  deleteDocument();
    },

    onChange(info) {
      if (info.file.status !== "uploading") {
      }

      if (info.file.status === "done") {
        message.success(`${info.file.name} file uploaded successfully`);
      } else if (info.file.status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
  };

  const onChangeDate = (date, dateString) => {
    setCurrentDatePicker(dateString);
  };

  const changerangePicker = (date, dateString) => {
    setFromDate(dateString?.[0]);
    setToDate(dateString?.[1]);
    setRangeDates(date);
  };
  return (
    <div className="repaymentContainer">
      <div>
        <Card className="repaymentContainer_child">
          <Form
            {...layout}
            form={form}
            name="control-hooks"
            onFinish={onFinish}
          >
            <br />
            <Form.Item
              className="radio-antd-notify"
              name="scheluderType"
              rules={[
                {
                  required: true,
                  message: "Scheduler Type is mandatory",
                },
              ]}
            >
              <Row justify={"center"}>
                <Radio.Group onChange={onChangeRadio}>
                  <Radio value={"Instant"}>Instant</Radio>
                  <Radio value={"Scheduled"}>Scheduled</Radio>
                </Radio.Group>
              </Row>
            </Form.Item>

            <Row gutter={[32, 32]} justify={"center"}>
              <Col lg={10} xs={24} sm={24} md={24}>
                <Form.Item
                  name="title"
                  rules={[
                    {
                      required: true,
                      message: "Title is mandatory",
                    },
                  ]}
                >
                  <InputTextField
                    disabled={false}
                    placeholder="Title"
                    label={"Title"}
                    style={{
                      width: "100%",
                      padding: "0.5rem",
                      paddingTop: ".9rem",
                    }}
                    // type={"dropdown"}
                    // options={payStatus}
                  />
                </Form.Item>
              </Col>
              <Col lg={8} xs={24} sm={24} md={24}>
                <Form.Item
                  name="pageName"
                  rules={[
                    {
                      required: true,
                      message: "Page Name is mandatory",
                    },
                  ]}
                >
                  <InputTextField
                    disabled={false}
                    // placeholder="Page Name"
                    label={"Page Name"}
                    style={{
                      width: "100%",
                      padding: "0.5rem",
                    }}
                    type={"dropdown"}
                    options={dropdownNames}
                  />
                </Form.Item>
              </Col>
              <Col lg={10} xs={24} sm={24}>
                {" "}
                <Form.Item
                  name="message"
                  rules={[
                    {
                      required: true,
                      message: "Message is mandatory",
                    },
                  ]}
                >
                  <InputTextField
                    label={"Message"}
                    placeholder={"Message"}
                    type="textarea"
                  />
                </Form.Item>
              </Col>
              <Col lg={8} xs={24} sm={24}>
                {" "}
                <Form.Item
                  name="group"
                  placeholder="Group"
                  rules={[
                    {
                      required: true,
                      message: "Group is mandatory",
                    },
                  ]}
                >
                  <InputTextField
                    disabled={false}
                    // placeholder="Page Name"
                    label={"Group"}
                    style={{
                      width: "100%",
                      padding: "0.5rem",
                    }}
                    type={"dropdown"}
                    options={groupDropdown}
                  />
                </Form.Item>
              </Col>

              <Col lg={10} xs={24} sm={24}>
                <Form.Item
                 value={rangeDates}
                  name="rangeTime"
                  rules={[
                    {
                      required: true,
                      message: "Date is mandatory",
                    },
                  ]}
                >
                  <RangePicker
                    style={{
                      width: "100%",
                      padding: "0.5rem",
                      paddingTop: ".9rem",
                      border: 0,
                      borderBottom: "1.5px solid #334e9e",
                    }}
                    onChange={changerangePicker}
                    placeholder={["From Date", "To Date"]}
                    type="date"
                    showToday={false}
                    disabledDate={(current) => {
                      const today = moment().startOf("day");

                      if (scheluderType === "Instant") {
                        return (
                          current &&
                          (current < today || current > today.endOf("day"))
                        );
                      } else if (scheluderType === "Scheduled") {
                        return current && current < today;
                      }
                      return false;
                    }}
                  />
                </Form.Item>
              </Col>

              <Col lg={8} xs={24} sm={24}>
                <Form.Item
                  name="notificationType"
                  rules={[
                    {
                      required: true,
                      message: "Notification Type is mandatory",
                    },
                  ]}
                >
                  <InputTextField
                    disabled={false}
                    // placeholder="Page Name"
                    label={"Notification Type"}
                    style={{
                      width: "100%",
                      padding: "0.5rem",
                    }}
                    type={"dropdown"}
                    options={notificationDropdown}
                  />
                </Form.Item>
              </Col>
            </Row>
            <br />
            <Row gutter={[32, 32]} justify={"center"}>
              {scheluderType === "Scheduled" && (
                <>
                  <Col lg={10} xs={24} sm={24}>
                    <Form.Item
                      name="startTimeDate"
                      
                      rules={[
                        {
                          required: true,
                          message: "start Time Date is mandatory",
                        },
                      ]}
                    >
                      <DatePicker
                        style={{
                          width: "100%",
                          padding: "0.5rem",
                          border: 0,
                          marginLeft: 0,
                          borderBottom: "1.5px solid #334e9e",
                        }}
                        onChange={onChangeDate}
                        disabledDate={(current) =>
                          moment().add(-1, "days") >= current
                        }
                        showToday={false}
                        placeholder="Start Time Date"
                        type="date"
                      />
                    </Form.Item>
                  </Col>

                  <Col lg={8} xs={24} sm={24}>
                    <Form.Item
                      name="startTime"
                      rules={[
                        {
                          required: true,
                          message: "start Time is mandatory",
                        },
                      ]}
                    >
                      <TimePicker
                        disabled={currentDatePicker === ""}
                        disabledHours={() => {
                          if (currentHour === 0) return [];
                          if (currentDatePicker === currentDate) {
                            return range(0, currentHour - 1); // e.g., block earlier hours
                          }
                          return [];
                        }}
                        style={{
                          width: "100%",
                          padding: "0.5rem",
                          border: 0,
                          borderBottom: "1.5px solid #334e9e",
                        }}
                        format={format}
                        showTime={false}
                      />
                    </Form.Item>
                  </Col>
                </>
              )}
            </Row>
            <br />
            <Row justify={"center"}>
              <Button
                loading={loading}
                className="save-button-bg-blue btnRepay"
                htmlType="submit"
              >
                Submit
              </Button>
            </Row>
          </Form>
        </Card>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = {
  uploadDocument,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomerNotification);
